import { useMemo } from "react";
import { useSelector } from "react-redux";
import { enums} from "../../common/lib";

/**
 * Use reissued asset status
 * 1. All expected should have decision approve/reject
 * 2. All unexpected should be resolved
 * 3. No assignments should be reissued
 * 4. All assignments should be submitted or recalled
 */
export default () => {
    const { auditReview, auditAssignments } = useSelector((state) => state);
    return useMemo(() => {
        // all assignments should be submitted
        const reissueAllowedStatuses = [
            enums.status.auditAssignment.submitted,
            enums.status.auditAssignment.recalled
        ];

        // Block popup if any reissued assignment is still pending (not submitted/recalled)
        const hasUnaddressedReissuedAssignment =
            auditAssignments.data.length > 0 &&
            auditAssignments.data.some(
                (el) =>
                    el.is_reissued === true &&
                    !reissueAllowedStatuses.includes(Number(el.status))
            );

        if (hasUnaddressedReissuedAssignment) return false;

        // All assignments must be submitted or recalled
        const canReissue =
            auditAssignments.data.length > 0 &&
            auditAssignments.data.every((el) =>
                reissueAllowedStatuses.includes(Number(el.status))
            );

        if (canReissue !== true) return false;

        if (auditReview.altAssets.total === undefined) {
            const expectedAssetDecisionTotal =
                auditReview.auditAssets.approved +
                auditReview.auditAssets.rejected;
            const expectedAssetComplete =
                auditReview.auditAssets.total === expectedAssetDecisionTotal
                    ? true
                    : false;
            return (
                expectedAssetComplete &&
                auditReview.auditAssets.reissued > 0
            );
        } else {
            const expectedAssetDecisionTotal =
                auditReview.auditAssets.approved +
                auditReview.auditAssets.rejected;
            const expectedAssetComplete =
                auditReview.auditAssets.total === expectedAssetDecisionTotal
                    ? true
                    : false;
            const unExpectedAssetComplete =
                auditReview.altAssets.total &&
                auditReview.altAssets.total - auditReview.altAssets.resolved ===
                    0
                    ? true
                    : false;

            return (
                expectedAssetComplete &&
                unExpectedAssetComplete &&
                auditReview.auditAssets.seenPending === 0 &&
                auditReview.auditAssets.reissued > 0
            );
        }
    }, [auditReview, auditAssignments]);
};
